import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  height: 10vh;
  width: calc(100vw - 10%);
  max-width: 1920px;
  background-color: #fff;
  padding: 0 5%;
  position: fixed;
  top: 0;
  z-index: 10;
  .logo-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    .navbarLogo {
      width: 5%;
      height: 5%;
      min-height: 30px;
      min-width: 30px;
    }
    h4 {
      width: 70%;
      font-family: "Roboto", sans-serif;
      display: none;
    }
  }
  ul {
    display: flex;
    list-style: none;
    width: fit-content;
    align-items: center;
    justify-content: space-between;
    width: fit-content;
    padding: 0;
    li {
      list-style: none;
      width: fit-content;
      padding: 0 1rem 0 0;
      a {
        color: #333333;
        width: 100%;
        font-weight: 400;
        font-family: "Poppins";
        text-decoration: none;
        text-transform: uppercase;
        font-size: 12px;
      }
      &:last-of-type {
        padding: 0;
      }
    }
    .servicis {
      color: #333333;
      font-family: "Poppins";
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 400;
      font-size: 12px;
      cursor: pointer;
      position: relative;
      .servicis-submenu {
        display: none;
        top: 20px;
        right: 0;
        width: 100px;
        padding: 0.5rem;
        position: absolute;
        background: #f5f5f5;
        li {
          width: fit-content;
          &:hover {
            background: #ccc;
          }
          a {
            font-size: 12px;
          }
        }
        &:hover > .servicis-submenu {
          display: block;
        }
      }
    }

    .servicis:hover > .servicis-submenu {
      display: block;
    }
    #logoutButton {
      .visible {
        display: block;
      }
      &.hidden {
        display: none;
      }
    }
  }
  img {
    width: 40%;
  }
  @media (min-width: 867px) {
    padding: 0 5%;
    width: calc(100vw - 10%);
    .logo-container {
      .navbarLogo {
        width: 5%;
      }
      h4 {
        width: auto;
        padding-left: 1rem;
        display: block;
        justify-content: center;
      }
    }
    ul {
      width: 30%;
      li a {
        font-size: 16px;
      }
      .servicis {
        font-size: 16px;
      }
    }
    ul .servicis .servicis-submenu {
      width: 150px;
      li a {
        font-size: 14px;
      }
    }
  }
`;
